import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => localStorage.getItem('theme') || 'dark');
  const [isAscii, setIsAscii] = useState(() => localStorage.getItem('ascii') === 'true');

  useEffect(() => {
    // Derive combined data-theme so existing CSS selectors keep working
    const combined = isAscii
      ? (theme === 'dark' ? 'ascii' : 'ascii-light')
      : theme;
    document.body.setAttribute('data-theme', combined);
    localStorage.setItem('theme', theme);
    localStorage.setItem('ascii', String(isAscii));
  }, [theme, isAscii]);

  const toggleTheme = () => setTheme(prev => prev === 'light' ? 'dark' : 'light');
  const toggleAscii = () => setIsAscii(prev => !prev);

  return (
    <ThemeContext.Provider value={{ theme, isAscii, toggleTheme, toggleAscii }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
